<ng-container *ngIf="repository.labomates$ | async as labomates">
  <div
    class="where-use grid"
    style="z-index: 1"
    *ngIf="labomates.length; else emptyLabomats"
  >
    <div class="grid-item grid-6 grid-sm-12 where-use-p">
      <ng-container [ngTemplateOutlet]="templateWhereUse"></ng-container>

      <div class="grid grid-nowrap">
        <img
          class="grid-item no-shrink mr-16 relative"
          style="top: -3px"
          [class]="isSM ? 'h-40' : 'h-48'"
          [src]="images.point"
          [alt]="images.point"
        />
        <div>
          <div class="typography typography-h2 green-basic mb-8">
            {{ labomates.length }}
            {{ "лабомат" | declension : labomates.length : ["", "а", "ов"] }}
          </div>
          <div
            class="typography typography-bold typography-headline grey-800 mb-8"
          >
            в Центрах Хеликс
          </div>
          <div class="typography grey-800">
            (доступно взятие биоматериала медсестрой)
          </div>
        </div>
      </div>

      <div class="max-w-448" *ngIf="!isSM">
        <ng-container [ngTemplateOutlet]="templatePrompt"></ng-container>
      </div>
    </div>

    <div
      class="grid-item grid-6 grid-sm-12 min-h-288 max-h-768"
      [style]="isSM ? 'height: 60vh' : ''"
    >
      <app-lab-pas-map></app-lab-pas-map>
    </div>

    <div class="px-32 full-width" *ngIf="isSM">
      <ng-container [ngTemplateOutlet]="templatePrompt"></ng-container>
    </div>
  </div>
</ng-container>

<ng-template #emptyLabomats>
  <div class="where-use where-use-bg grid">
    <div class="grid-item grid-6 grid-sm-12 where-use-empty-p">
      <ng-container [ngTemplateOutlet]="templateWhereUse"></ng-container>

      <div class="grid justify-content-sm-center align-items-start">
        <img
          class="full-width max-w-384 hidden block-sm mb-28"
          [src]="images.emptyMap"
          [alt]="images.emptyMap"
        />

        <div class="grid-item full-width">
          <div
            class="grid grid-gutter-24 grid-sm-nowrap grid-xs-column justify-content-between"
          >
            <div
              class="grid-item typography typography-headline typography-xs-centered grey-800"
            >
              К сожалению, в вашем городе нет Helix Express. Напишите нам, если
              вам интересен такой формат.
            </div>

            <div
              class="grid-item grid justify-content-center align-items-start"
            >
              <button
                class="button button-primary button-m nowrap"
                (click)="writeToHelixModalService.openProposal()"
              >
                Написать в Хеликс
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #templateWhereUse>
  <div class="typography typography-h4 typography-bold green-basic mb-40">
    Где можно воспользоваться услугой?
  </div>

  <div
    class="typography centered-y grey-900 mb-48"
    [class]="isSM ? 'typography-headline' : 'typography-h3'"
  >
    <div
      class="icon icon-direction-tiled mr-8 grey-800"
      [class]="isSM ? 'icon-24' : 'icon-32'"
      style="top: -2px"
    ></div>
    {{ repository.city$ | async }}
  </div>
</ng-template>

<ng-template #templatePrompt>
  <div class="where-use-line mt-48 mb-16"></div>

  <div class="mb-36 typography">
    Полный список доступен при заказе анализов в&nbsp;<span
      class="typography typography-underline green-basic link"
      (click)="scrollToApps()"
      >мобильном приложении Helix Express</span
    >.
  </div>
</ng-template>
